<script lang="ts">
	import { page } from '$app/stores';

	import FirstLevelMenu from '$lib/components/molecules/FirstLevelMenu/FirstLevelMenu.svelte';
	import SecondLevelMenu from '$lib/components/molecules/SecondLevelMenu/SecondLevelMenu.svelte';

	import { type MenuItem } from '$lib/utils/menu';

	interface Props {
		menu?: MenuItem[];
	}

	let { menu = [] }: Props = $props();

	const getActiveMenuItem = (pathname: string) => {
		const active = menu.find(
			(item) => item.onClick?.data === pathname || item.matcher?.(pathname)
		);
		return active ? active.parent : null;
	};

	let activeFirstLevelItem = $derived(getActiveMenuItem($page.url.pathname));

	let secondLevelItems = $derived(
		activeFirstLevelItem ? menu.filter((item) => item.parent === activeFirstLevelItem) : []
	);

	const onActiveMenuItemChange = (detail: string) => {
		activeFirstLevelItem = detail;
	};
</script>

<nav class="SidebarDesktop" class:SidebarDesktop--compact={secondLevelItems.length === 0}>
	<div class="SidebarDesktop__first-level-menu">
		<FirstLevelMenu
			{menu}
			onChange={onActiveMenuItemChange}
			selectedItem={activeFirstLevelItem}
			useDefaultPage
		></FirstLevelMenu>
	</div>
	{#if secondLevelItems.length > 0}
		<div class="SidebarDesktop__second-level-menu">
			<SecondLevelMenu menu={secondLevelItems}></SecondLevelMenu>
		</div>
	{/if}
</nav>

<style lang="scss" src="./SideBarDesktop.scss"></style>
